// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { API_CONSTANTS } from '@client/app/core/constants/api.constant';

interface PaginatedCollection {
    total?: number;
    currentPage?: number;
    perPage?: number;
    length?: number;
}

@Component({
    selector: 'table-container',
    templateUrl: './table-container.component.html',
    standalone: false,
})
export class TableContainerComponent implements OnInit, OnChanges {
    @Input() disablePagination: boolean = false;
    @Input() collection: PaginatedCollection = {};
    @Input() pageSizes: string[] = ['10', '25', '50'];
    @Input() progress: any = null;
    @Input() noResultMessage: string = '';

    @Output() onPageChange = new EventEmitter<number>();
    @Output() onPerPageChange = new EventEmitter<string>();

    defaultPageSize: number = API_CONSTANTS.PAGE_SIZE;
    showProgress: boolean = false;
    showTable: boolean = false;

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnChanges (changes: SimpleChanges) {
        if (changes.progress) {
            this.setupWatchers();
        }
    }

    private activate (): void {
        this.loading();
        this.disablePagination = this.disablePagination || false;

        this.progress = this.progress || null;
        this.collection = this.collection || {};
        this.pageSizes = this.pageSizes || ['10', '25', '50'];
        this.noResultMessage = this.noResultMessage || this.translateService.getString('No content was found');

        this.setupWatchers();
    }

    private setupWatchers (): void {
        // Watch for progress changes
        if (this.progress !== null && this.progress !== undefined && this.progress !== false) {
            this.isProgressRunning();
        } else {
            this.doneLoading();
        }
    }

    showPagination (): boolean {
        return Number(this.collection ? this.collection.total : 0) > this.getPageSize();
    }

    getPageSize (): number {
        let pageSize = this.defaultPageSize;
        if (typeof this.collection === 'object') {
            pageSize = this.collection.perPage || pageSize;
        }

        return Number(pageSize);
    }

    pageChange (): void {
        this.onPageChange.emit(this.collection.currentPage || 1);
    }

    pageSizeChange (size: string): void {
        this.onPerPageChange.emit(size);
    }

    private isProgressRunning (): void {
        this.loading();

        if (this.progress && typeof this.progress.then === 'function') {
            this.progress.finally(() => {
                setTimeout(() => {
                    if (this.collection !== undefined) {
                        this.collection.total = this.collection.total ?? this.collection.length ?? 0;
                        this.doneLoading();
                        this.showTable = (this.collection.total || 0) > 0;
                    } else {
                        this.doneLoading();
                    }
                });
            });
        } else {
            setTimeout(() => {
                if (this.collection !== undefined) {
                    this.collection.total = this.collection.total ?? this.collection.length ?? 0;
                    this.doneLoading();
                    this.showTable = (this.collection.total || 0) > 0;
                } else {
                    this.doneLoading();
                }
            });
        }
    }

    shownNoResultMessage (): boolean {
        return !this.showProgress && (this.collection.total || 0) === 0 && this.noResultMessage.length > 0;
    }

    private loading (): void {
        this.showProgress = true;
        this.showTable = false;
    }

    private doneLoading (): void {
        this.showProgress = false;
        this.showTable = true;
    }
}
